'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { CARD_FINDER_OPEN_ACTION } from 'src/features/navigation/Entrypoint/constants';
import { SecondaryLink } from './SecondaryLink';
import { getEntryPointUrl } from './utils';
export function EntrypointMobileButton(t0) {
  const $ = _c(14);
  const {
    entitySection: t1
  } = t0;
  const entitySection = t1 === undefined ? "cardfinder_entry" : t1;
  let t2;
  if ($[0] !== entitySection) {
    t2 = {
      ...CARD_FINDER_OPEN_ACTION,
      actionSection: entitySection
    };
    $[0] = entitySection;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const firePageAction = usePageAction(t2);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: 12,
      md: 2
    };
    t4 = {
      marginTop: {
        xs: 3,
        md: 0
      }
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getEntryPointUrl();
    t6 = {
      height: "3rem"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== firePageAction) {
    t7 = () => firePageAction();
    $[6] = firePageAction;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Typography variant="accent">Take Quiz</Typography>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7) {
    t9 = <Grid size={t3} sx={t4}><SecondaryLink href={t5} sx={t6} onClick={t7}>{t8}</SecondaryLink></Grid>;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== entitySection || $[12] !== t9) {
    t10 = <FeatureViewed entityName="cc_recommend_flow" entitySection={entitySection} impressionPosition={0}>{t9}</FeatureViewed>;
    $[11] = entitySection;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
}